import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/performance-marketing/meta-ads")({
  component: () => <Outlet />,
});
